import { useChainId } from 'wagmi';
import { useDataForSigning } from './useDataForSigning';

/**
 * Checks that the chain ID returned from the sequencer matches the chain ID
 * connected to locally.
 */
export const useNetworkIsValid = () => {
  const { domain, isPending, error } = useDataForSigning();
  const chainId = useChainId();

  return {
    data: domain?.chainId === chainId,
    isPending: isPending,
    error,
  };
};
